import React, { useState, useEffect } from 'react';

import './css/index.css';
import img from '../../../assets/images/newLogo.png';
import Layout from '../../../components/Layout';
import Registerform from './RegisterForm';
import { useLocation } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

export default function Register(props) {
  const [redirect, setRedirect] = useState(false);
  const location = useLocation();
  let { price, packageName } = location.state || {
    price: null,
    packageName: null,
  };
  useEffect(() => {
    if (!price) {
      setRedirect(true);
    }
  }, []);
  return (
    <Layout {...props}>
      {redirect && <Redirect to={{ pathname: '/' }} />}
      <div className="folder">
        <div className="file">
          <div className="imageField">
            <img src={img} alt="logo" />
          </div>

          <div className="this">
            <h1>
              <span>PACKAGE: </span>
              {packageName}
            </h1>
            <h2>Registration & Payment</h2>
            <div className="accForm newaccform">
              <div className="fieldContent">
                <Registerform price={price} packageName={packageName} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
